import { takeLatest } from "redux-saga/effects";
import { SUBSCRIPTION_ACTION_TYPES } from "../actionTypes";
import {
  identifyUser,
  setUserProfile,
  setUserProfiles
} from "./UserProfileSagas";

export function* UserProfileFromWatcher() {
  yield takeLatest(
    SUBSCRIPTION_ACTION_TYPES.USER_PROFILE.IDENTIFY_USER,
    identifyUser
  );
  yield takeLatest(
    SUBSCRIPTION_ACTION_TYPES.USER_PROFILE.IDENTIFY_PROFILE,
    setUserProfile
  );
  yield takeLatest(
    SUBSCRIPTION_ACTION_TYPES.USER_PROFILE.IDENTIFY_PROFILES,
    setUserProfiles
  );
}
